import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/service_banner.png"; // Replace with actual path
function ServiceTitle() {
    return (
        <div className="service-title">
            <HeroSection image={Banner} pageTitle="Our Services" />
            <section className="partner-section d-flex flex-column justify-content-center align-items-center text-center ">
                <div className="container">
                    <h2 className="fw-normal">Delivering seamless, end-to-end <br className="d-none d-lg-block"/>
                        event solutions.</h2>
                </div>
            </section>
        </div>
    );
}

export default ServiceTitle;
